import modaal from 'modaal'

$('.js-gallery-modal').modaal({
  type: 'image',
})

$('#js-video-modal').modaal({
  type: 'video',
})

// $('.js-line-regist').modaal()
// $('.js-line-regist').modaal({
//   fullscreen: true
// })
